/**
 * user behavior
 * author: leo
 * date: 2024-02-28
 */

function generateRandomId() {
    return Math.random().toString(36).substring(2);
}

function generateSessionId() {
    var sessionId = sessionStorage.getItem("heychicSessionId");
    if (!sessionId) {
        sessionId = generateRandomId();
        sessionStorage.setItem("heychicSessionId", sessionId);
    }
    return sessionId;
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return "";
}

function handleEvent(page) {
    const getUrl = window.location.pathname;
    let pageJson = '';
    if(getUrl.indexOf("collections") > -1 && page || (page== "add to cart" || page == "buy it now")){
      const handleObj = {
        event_name:page== "add to cart" || page == "buy it now"?"product_detail_click":"collection_detail_click",
        collections:getUrl.split('/')[getUrl.split('/').length - 1], // 获取最后一个/后面的值
        position:page
      }
      pageJson = JSON.stringify(handleObj) || ''
    }
    const data = {
        ua: navigator.userAgent,
        u_w: screen.width,
        u_h: screen.height,
        customerId: customerLoginId,
        page: 
        (getUrl.indexOf("collections") > -1 && page && getUrl.indexOf("/products") == -1) || (page== "add to cart" || page == "buy it now") ? pageJson 
        : getUrl.indexOf("/products") > -1 && page ? page : window.location.href,
        time: new Date().getTime(),
        ref: document.referrer,
        clientId: localStorage.getItem("clientId"),
        csid: heychicSessionId,
        cartId: cartId,
        cpid: cpid,
        tzo: new Date().getTimezoneOffset(),
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        // 'shop_id':'66793275449',//测试
        'shop_id':'59363262637' //正式

    };

    // url参数是否上报
    const urlParamsSearch = new URLSearchParams(window.location.search);

    // 判断参数是否存在
    if (urlParamsSearch.has('no_report')) {
        const getReport = urlParamsSearch.get('no_report'); // 可能为空字符串
        if (page === 'true' || getReport === 'true') {
            console.log('不执行上报');
            return;
        }
    }

    const queryString = Object.keys(data)
        .map((key) => key + "=" + encodeURIComponent(data[key]))
        .join("&");
    new Image().src =
        `/apps/user-api/web/analysis/log?` + queryString; //正式
}

var customerLoginId;
if (ShopifyAnalytics.meta.page.customerId) {
    customerLoginId = ShopifyAnalytics.meta.page.customerId;
} else {
    customerLoginId = "";
}
var cartId = getCookie("cart");
var heychicSessionId = generateSessionId();
var cpid = '';
handleEvent();

var addButton = document.getElementById("product-add-to-cart");
if (addButton) {
    addButton.addEventListener("click", function () {
        cpid = ShopifyAnalytics.meta.product.id;
        if (cpid) {
            // handleEvent('add to cart');
        }
        console.log("click add to cart", cpid);
    });
}